const SAMPLE_SECRETARIES = [
  { fullName: 'سعود مشعل العتيبي', userBase: 'saud.alotaibi' },
  { fullName: 'منى سعد النمر', userBase: 'muna.s.alnemer' },
  { fullName: 'عبدالإله زيد المطيري', userBase: 'abdalelah.almutairi' },
  { fullName: 'رنا خالد الدوسري', userBase: 'rana.aldosari' },
  { fullName: 'مشعل هادي الشمري', userBase: 'meshal.alshehri' },
  { fullName: 'لطيفة ماجد القحطاني', userBase: 'lateefa.alqahtani' },
];

/**
 * Realistic sample for new secretary. Username and email get a unique tail to avoid API conflicts.
 */
export function getSampleSecretaryUserForm() {
  const n = Date.now();
  const tail = String(n).slice(-5);
  const i = n % SAMPLE_SECRETARIES.length;
  const { fullName, userBase } = SAMPLE_SECRETARIES[i];
  const mobile8 = String(10000000 + (n % 90000000)).padStart(8, '0').slice(0, 8);
  return {
    userName: `${userBase}.${tail}`,
    fullName,
    email: `${userBase}.${tail}@mithaq.sa`,
    phone: `05${mobile8}`,
    password: 'CorpPass@2024',
    isActive: true,
  };
}
